(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fpc-cart-donation"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fpc-cart-donation')) return;
  class FpcCartDonation extends HTMLElement {
    connectedCallback() {
      // Also initializes when the Shopify theme editor reloads this section.
      requestAnimationFrame(() => { if (this.isConnected && !this.controller) this.init(); });
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
    init() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.config = {
        variant: Number(this.dataset.variantId),
        productURL: this.dataset.productUrl,
        recipient: this.dataset.recipient,
        currency: this.dataset.currency,
        max: Number(this.dataset.max),
        root: (window.Shopify?.routes?.root || this.dataset.root || '/').replace(/\/?$/, '/')
      };
      this.selected = 0; this.busy = false; this.ready = false; this.lines = [];
      this.controls = this.querySelector('[data-controls]');
      this.saveButton = this.querySelector('[data-save]');
      this.removeButton = this.querySelector('[data-remove]');
      this.input = this.querySelector('[data-custom]');
      this.status = this.querySelector('[data-status]');
      this.querySelectorAll('[data-amount]').forEach(button => button.addEventListener('click', () => {
        const custom = button.dataset.amount === 'custom';
        this.mode = custom ? 'custom' : 'preset';
        this.selected = custom ? this.parseAmount(this.input.value) : Number(button.dataset.amount);
        this.querySelectorAll('[data-amount]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelector('[data-custom-wrap]').hidden = !custom;
        this.querySelector('[data-amount="custom"]').setAttribute('aria-expanded', String(custom));
        if (custom) this.input.focus();
        this.message(''); this.renderControls();
      }, options));
      this.input.addEventListener('input', () => {
        this.selected = this.parseAmount(this.input.value);
        this.input.setAttribute('aria-invalid', String(this.input.value !== '' && !this.selected));
        this.message(this.input.value && !this.selected ? `Enter a whole-dollar amount from $1 to $${this.config.max}.` : '', Boolean(this.input.value && !this.selected));
        this.renderControls();
      }, options);
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); event.stopPropagation(); if (!this.saveButton.disabled) this.save(false); }
      }, options);
      this.saveButton.addEventListener('click', () => this.save(false), options);
      this.removeButton.addEventListener('click', () => this.save(true), options);
      this.querySelector('[data-refresh]').addEventListener('click', () => window.location.reload(), options);
      // Prevent a same-page checkout click while the contribution is being saved.
      document.addEventListener('click', event => {
        if (this.busy && event.target instanceof Element && event.target.closest('[name="checkout"], a[href*="/checkout"]')) {
          event.preventDefault(); event.stopImmediatePropagation(); this.message('Please wait while your contribution is saved.');
        }
      }, { ...options, capture: true });
      document.addEventListener('submit', event => {
        if (this.busy) { event.preventDefault(); event.stopImmediatePropagation(); this.message('Please wait while your contribution is saved.'); }
      }, { ...options, capture: true });
      window.addEventListener('pageshow', event => { if (event.persisted && !this.busy) this.load(); }, options);
      this.load();
    }
    parseAmount(value) {
      const cleaned = String(value).trim();
      const amount = /^\d+$/.test(cleaned) ? Number(cleaned) : 0;
      return Number.isSafeInteger(amount) && amount >= 1 && amount <= this.config.max ? amount : 0;
    }
    money(cents, currency = this.config.currency) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', { style:'currency', currency, currencyDisplay:'code' }).format(cents / 100);
    }
    async request(path, payload) {
      const timeout = new AbortController();
      const timer = setTimeout(() => timeout.abort(), 15000);
      try {
        const response = await fetch(path, {
          method: payload === undefined ? 'GET' : 'POST',
          credentials:'same-origin', cache:'no-store', signal:timeout.signal,
          headers:{ Accept:'application/json', ...(payload === undefined ? {} : { 'Content-Type':'application/json' }) },
          ...(payload === undefined ? {} : { body:JSON.stringify(payload) })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Shopify could not save the contribution. Please refresh the cart and try again.');
        return data;
      } catch (error) {
        if (error.name === 'AbortError') throw new Error('The request took too long. Refresh your cart to check whether the contribution was saved.');
        throw error;
      } finally { clearTimeout(timer); }
    }
    cart() { return this.request(this.config.root + 'cart.js'); }
    managed(cart) { return cart.items.filter(item => item.properties?._fpc_donation === 'v1'); }
    mismatch(cart) {
      return this.managed(cart).some(item => Number(item.variant_id) !== this.config.variant || item.properties?.Recipient !== this.config.recipient) ||
        cart.items.some(item => Number(item.variant_id) === this.config.variant && item.properties?._fpc_donation !== 'v1');
    }
    productEndpoint() {
      const url = new URL(this.config.productURL, window.location.origin);
      url.search = ''; url.hash = '';
      if (url.origin !== window.location.origin) throw new Error('Contributions are temporarily unavailable.');
      if (!url.pathname.startsWith(this.config.root)) url.pathname = this.config.root + url.pathname.replace(/^\//, '');
      url.pathname = url.pathname.replace(/\.js$/, '') + '.js';
      return url.href;
    }
    validateProduct(product, cart) {
      const variant = product.variants?.find(item => Number(item.id) === this.config.variant);
      if (!['CAD','USD'].includes(cart.currency) || cart.currency !== this.config.currency || !variant || variant.price !== 100 || !variant.available || variant.requires_shipping || variant.inventory_management || product.requires_selling_plan) {
        throw new Error(`Contributions are temporarily unavailable in ${cart.currency}. You can continue shopping without contributing.`);
      }
      return variant;
    }
    sync(cart) {
      this.lastCart = cart; this.lines = this.managed(cart); this.conflict = this.mismatch(cart);
      this.total = this.lines.reduce((sum,item) => sum + item.final_line_price, 0);
      const recipients = [...new Set(this.lines.map(item => item.properties.Recipient || 'the recorded organization'))].join(', ');
      const current = this.querySelector('[data-current]');
      current.hidden = !this.lines.length;
      current.textContent = this.lines.length ? `In your cart: ${this.money(this.total, cart.currency)} for ${recipients}.` : '';
      this.removeButton.hidden = !this.lines.length;
      this.querySelectorAll('[data-currency-label]').forEach(el => { el.textContent = `(${cart.currency})`; });
      this.renderControls();
    }
    renderControls() {
      this.controls.disabled = this.busy || !this.ready || this.conflict;
      this.saveButton.disabled = this.busy || !this.ready || this.conflict || !this.selected;
      this.removeButton.disabled = this.busy;
      this.setAttribute('aria-busy', String(this.busy));
      this.saveButton.textContent = this.busy ? 'Saving…' : this.selected ? `${this.lines.length ? 'Update to' : 'Add'} ${this.money(this.selected * 100)} contribution` : 'Add contribution';
    }
    message(text, error = false) { this.status.textContent = text; this.status.dataset.error = String(error); }
    async load() {
      this.ready = false; this.renderControls();
      try {
        // Read cart first, so an existing contribution can still be removed if
        // the product was unpublished, repriced, or replaced since it was added.
        const cart = await this.cart();
        if (!this.isConnected) return;
        this.sync(cart);
        const product = await this.request(this.productEndpoint());
        if (!this.isConnected) return;
        this.validateProduct(product, cart); this.ready = true; this.renderControls();
        this.message(this.conflict ? 'Your cart already contains a contribution from another setup or recipient. Remove that contribution in the cart before adding a new one.' : 'Choose an amount, then select Add contribution. Giving is optional.', this.conflict);
      } catch (error) {
        if (!this.isConnected) return;
        this.message(error.message || 'Contributions are temporarily unavailable. Please refresh your cart.', true);
        this.querySelector('[data-refresh]').hidden = false;
      }
    }
    async save(remove) {
      if (this.busy || (!remove && (!this.ready || this.conflict || !this.parseAmount(this.selected)))) return;
      const desired = remove ? 0 : this.selected;
      this.busy = true; this.renderControls(); this.message(remove ? 'Removing contribution…' : 'Saving your contribution…');
      try {
        // Every operation starts with current line keys; other cart contents
        // are never reconstructed, cleared, or posted back in an updates array.
        let cart = await this.cart();
        const lines = this.managed(cart);
        if (!remove) {
          this.validateProduct(await this.request(this.productEndpoint()), cart);
          if (this.mismatch(cart)) throw new Error('Another contribution is already in your cart. Remove it before changing the recipient.');
        }
        if (lines.length) {
          if (lines.length === 1) {
            cart = await this.request(this.config.root + 'cart/change.js', { id:lines[0].key, quantity:desired });
          } else {
            const updates = {};
            lines.forEach((item,index) => { updates[item.key] = !remove && index === 0 ? desired : 0; });
            cart = await this.request(this.config.root + 'cart/update.js', { updates });
          }
        } else if (!remove) {
          await this.request(this.config.root + 'cart/add.js', { items:[{
            id:this.config.variant, quantity:desired,
            properties:{ Recipient:this.config.recipient, 'Tax receipt':'Not issued', _fpc_donation:'v1' }
          }] });
          cart = await this.cart();
        }
        this.sync(cart);
        const count = this.lines.reduce((sum,item) => sum + item.quantity, 0);
        if (count !== desired || (!remove && (this.total !== desired * 100 || this.conflict))) {
          throw new Error('Shopify changed the contribution amount or applied a discount. Refresh your cart and review the actual total before checkout.');
        }
        this.message(remove ? 'Contribution removed. Refreshing your cart…' : 'Contribution saved. Refreshing your cart…');
        window.location.reload();
      } catch (error) {
        // An interrupted or rejected request can still have changed the cart.
        // Re-read it once; never blindly repeat a money-changing request.
        try { this.sync(await this.cart()); } catch (_) { /* The refresh link remains available. */ }
        this.message(error.message || 'We could not confirm the update. Refresh your cart to check the contribution.', true);
        this.querySelector('[data-refresh]').hidden = false;
        this.busy = false; this.renderControls();
      }
    }
  }
  customElements.define('fpc-cart-donation', FpcCartDonation);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
